/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { SearchFilterPortal } from 'js/searches/controls/layout/search_filter_button';
import FacetPanel from '../panels/facet_panel';
import FacetPreloader from './facet_preloader';

const { LP, $ } = window;
const LpBoclips = LP.module('LpBoclips');

const FacetSidebar = ({ context }) => {
  const [viewAllVideosPage, setViewAllVideosPage] = useState();
  const [state, setState] = useState({ panels: {}, panelsLoaded: false });
  const [open, setOpen] = useState(false);

  const classNames = [];

  if (window.LP.isMobile()) {
    classNames.push('mb-10');
  }

  if (open) {
    classNames.push('open');
  }

  const panelStore = context.getStore('PanelStore');

  const getPanelsForUser = (panels, isLoggedIn) => {
    if (!isLoggedIn) {
      return panels.filter((key) => ['type_ids', 'grade_ids', 'subject_ids'].includes(key));
    }
    return panels;
  };

  let boclipsStore;
  if (
    LpBoclips != null &&
    LpBoclips.VideoModeStore != null &&
    $('#boclips-videos-section').length === 1
  ) {
    boclipsStore = context.getStore('VideoModeStore');
  }

  const setPanelsFromStore = () => {
    const { _panels: panelsFromStore } = panelStore;
    setState({
      panels: panelsFromStore,
      panelsLoaded: Object.keys(panelsFromStore).length > 0
    });
  };

  const setViewAllVideosPageFromStore = () => {
    setViewAllVideosPage(boclipsStore?.validCanViewAll());
  };

  const onChange = () => {
    setViewAllVideosPageFromStore();
  };

  const toggle = () => {
    setOpen(!open);

    const elements = [
      'boclips-videos-section',
      'search-results',
      'footer',
      'js-selected-facets'
    ].map((id) => document.getElementById(id));
    const hiddenClasses = ['hidden', 'bs-xs:block'];

    if (open) {
      elements.forEach((el) => el && el.classList.remove(...hiddenClasses));
      window.scrollTo(0, 0);
    } else {
      elements.forEach((el) => el && el.classList.add(...hiddenClasses));
    }
  };

  useEffect(() => {
    if (state.panelsLoaded) {
      context.executeAction(LP.module('Searches').SearchActions.togglePanelCollapse, {
        keys: panelStore.keysFilteredBy('autoload')
      });
    }
  }, [state.panelsLoaded]);

  useEffect(() => {
    setViewAllVideosPageFromStore();
    setPanelsFromStore();
    boclipsStore?.addChangeListener(onChange);
    panelStore.addChangeListener(setPanelsFromStore);
    return () => {
      boclipsStore?.removeChangeListener(onChange);
      panelStore.removeChangeListener(setPanelsFromStore);
    };
  }, []);

  let content = <FacetPreloader />;
  let panels = getPanelsForUser(Object.keys(state.panels), LP.config.logged_in);

  if (panels.length) {
    content = (
      <div className={classNames.join(' ')}>
        {panels.map((panelKey) => {
          if (!viewAllVideosPage && state.panels[panelKey].onlyOnViewAllVideosPage) {
            return null;
          }

          return (
            <FacetPanel
              key={panelKey}
              context={context}
              panelId={panelKey}
              autoload={state.panels[panelKey].autoload}
              keyForFacetState={state.panels[panelKey].keyForFacetState}
            />
          );
        })}
      </div>
    );
  } else {
    content = null;
  }

  return (
    <>
      {content}
      <SearchFilterPortal onToggle={toggle} isOpen={open} />
    </>
  );
};

FacetSidebar.propTypes = {
  context: PropTypes.object
};

export default FacetSidebar;
